import baseUrl from "./baseUrl";

function exportExcel(data) {
  return {
    method: "post",
    url: `${baseUrl}/api/v1/dashboard/exportExcel`,
    data: data,
  };
}

export default exportExcel;
